import { AutoMap } from "@automapper/classes";
import { LimitDTO } from "./limit.dto";
import { ELIMSTestDTO } from "./ELIMS/elims-test.dto";

export class TestDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    name: string = ''
    @AutoMap()
    elimsUnitName: string = ''
    @AutoMap()
    displayedUnitName: string = ''
    @AutoMap()
    position: number = 1;
    @AutoMap()
    comparaisonLQ?: number;
    @AutoMap(() => ELIMSTestDTO)
    elimsTestList: ELIMSTestDTO[] = [];
    @AutoMap(() => LimitDTO)
    limitList: LimitDTO[] = [];
    @AutoMap()
    isSum: boolean = false;
}